import { render, staticRenderFns } from "./fileDetailFormWindow.vue?vue&type=template&id=478ddc0e&scoped=true&"
import script from "./fileDetailFormWindow.vue?vue&type=script&lang=js&"
export * from "./fileDetailFormWindow.vue?vue&type=script&lang=js&"
import style0 from "./fileDetailFormWindow.vue?vue&type=style&index=0&id=478ddc0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478ddc0e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('478ddc0e')) {
      api.createRecord('478ddc0e', component.options)
    } else {
      api.reload('478ddc0e', component.options)
    }
    module.hot.accept("./fileDetailFormWindow.vue?vue&type=template&id=478ddc0e&scoped=true&", function () {
      api.rerender('478ddc0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Job/uploadFile/fileDetailFormWindow.vue"
export default component.exports